module.exports = __webpack_public_path__ + "assets/24.jpg?ce7f9e23cbeeb2ced933dfe547712b7a";